// Export all desktop components
export { default as SplashScreen } from "./SplashScreen";
export { default as WalkthroughScreen } from "./WalkthroughScreen";
export { default as AboutScreen } from "./AboutScreen";
export { default as TermsConditionsScreen } from "./TermsConditionsScreen";
export { default as WelcomeScreen } from "./WelcomeScreen";
export { default as UploadOrScanScreen } from "./UploadOrScanScreen";
export { default as GalleryPermissionScreen } from "./GalleryPermissionScreen";
export { default as CameraPermissionScreen } from "./CameraPermissionScreen";
export { default as PermissionDeniedScreen } from "./PermissionDeniedScreen";
export { default as ImageNotPermittedScreen } from "./ImageNotPermittedScreen";
export { default as FaceResultScreen } from "./FaceResultScreen";
export { default as FaceScanningScreen } from "./FaceScanningScreen";
export { default as LoginScreen } from "./LoginScreen";
export { default as SignupScreen } from "./SignupScreen";
export { default as VerifyOtpScreen } from "./VerifyOtpScreen";
export { default as ProductViewScreen } from "./ProductViewScreen";
export { default as FilterViewScreen } from "./FilterViewScreen";
export { default as ShareViewScreen } from "./ShareViewScreen";
export { default as PhotoCaptureFlow } from "./PhotoCaptureFlow";
export { default as AuthenticationFlow } from "./AuthenticationFlow";

// Export types
export type {
  DesktopStep,
  PhotoCaptureStep,
  AuthStep,
  DesktopNavigationProps,
  FilterState,
  DesktopAuthData,
  PhotoCaptureData,
  PhotoCaptureFlowProps,
  AuthenticationFlowProps,
} from "./types";
